import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderActKC2MTRForInflationDistributionGql } from '../InflationDistributionModalQueries';

const requestId = 'uerUpdateWorkOrderActKC2MTRForInflationDistribution';

export interface IActKC2MtrChangeItems {
    inflationSeasonId: number | null;
    workOrderPriceId: number;
}

interface IUpdateInflationMtr {
    actKC2Id: number;
    useInflationMTR: boolean;
    actKC2MtrItems: IActKC2MtrChangeItems[];
}

export const useUpdateInflationMtr = (props: IUpdateInflationMtr) => {
    const { actKC2Id, useInflationMTR, actKC2MtrItems } = props;
    const dispatch = useDispatch();
    const [isSubmittedData, setIsSubmitted] = useState(false);

    const [updateWorkOrderActKC2MTR, status, error, updateWorkOrderActKC2MTRRequest] = useRequest({
        requestId,
        query: uerUpdateWorkOrderActKC2MTRForInflationDistributionGql,
        withEffect: false,
    });

    const [makeReset] = useResetStoreData({ requestId });

    const dataUpdateInflation = useMemo(
        () => updateWorkOrderActKC2MTR?.uerUpdateWorkOrderActKC2MTRForInflationDistribution,
        [updateWorkOrderActKC2MTR?.uerUpdateWorkOrderActKC2MTRForInflationDistribution],
    );

    const reset = useCallback(() => {
        setIsSubmitted(false);
        makeReset(undefined);
    }, [makeReset]);

    const handleCreateReport = useCallback(() => {
        ExportCSVReport(updateWorkOrderActKC2MTR?.uerUpdateWorkOrderActKC2MTRForInflationDistribution?.validation);
    }, [updateWorkOrderActKC2MTR?.uerUpdateWorkOrderActKC2MTRForInflationDistribution?.validation]);

    const makeRequest = useCallback(() => {
        setIsSubmitted(true);
        dispatch(
            updateWorkOrderActKC2MTRRequest({
                actKC2Id,
                useInflationMTR,
                actKC2MtrItems,
            }),
        );
    }, [actKC2Id, actKC2MtrItems, updateWorkOrderActKC2MTRRequest, dispatch, useInflationMTR]);

    return { dataUpdateInflation, status, reset, error, makeRequest, isSubmittedData, handleCreateReport };
};
